











































































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import HttpClient from "@/core/HttpResources/BaseHttpClient";
import ApiQueryOption from "@/models/base/ApiQueryOption.model";
import { Utils } from "@/core/Utils";
import Usuario from "@/models/usuarios/usuario.model";

@Component({})
export default class UsuarioCollapse extends Vue {
  @Prop() public action!: string;
  @Prop() public controller!: string;
  @Prop() public whereParams!: string;
  @Prop() public include!: string;
  @Prop() public value!: number | any;
  @Prop() public closable!: boolean;
  @Prop() public closeTitle!: string;
  @Prop() public title!: string;

  loading = false;

  user = null;
  client = new HttpClient(this.controller || "Usuario");

  get isCosable() {
    return this.closable === false ? false : true;
  }
  queryParams(): ApiQueryOption {
    let instace = new ApiQueryOption();
    instace.where = this.whereParams;
    instace.include = this.include || "Persona|Oficina.Direccion.Provincia";

    if (!instace.include) delete instace.include;
    return instace;
  }
  get isId() {
    return !isNaN(this.value);
  }

  async getDataAsync() {
    try {
      this.loading = true;
      let resource = this.action || String();
      if (this.value && this.isId) {
        resource += `${this.value}`;
      }
      let result = await this.client.getAsync<any>(
        resource,
        this.queryParams()
      );

      if (resource) {
        this.user = result;
        this.$emit("input", result ? result.id : null);
      } else {
        this.user = result[0];
        this.$emit("input", this.user);
      }

      this.$emit("change", this.user);
    } catch (e) {
      this.user = null;
      this.$emit("change", null);
    } finally {
      this.loading = false;
    }
  }

  getFoto(value: string) {
    return `data:image/jpg;base64, ${value}`;
  }
  @Watch("value", { deep: true, immediate: true })
  OnValueChange(value: any) {
    if (!value) {
      this.user = null;
      return;
    }
    if (isNaN(value)) {
      this.user = this.value;
      this.$emit("change", value);
    } else {
      this.getDataAsync();
    }
  }

  close() {
    this.user = null;
    this.$emit("close", null);
    this.$emit("input", null);
  }
}
